import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllWarehouse,
  loadSingleWarehouse,
  setSingleWarehouseNotFound,
} from "./WarehouseList.slice";

import {
  loadAllWarehouseAPI,
  loadSingleWarehouseAPI,
} from "./WarehouseList.api";

export const LOAD_ALL_WAREHOUSE = {
  LOADING: "Load all warehouse loading",
  SUCCESS: "Load all warehouse success",
  ERROR: "Load all warehouse error",
};

export const LOAD_SINGLE_WAREHOUSE = {
  LOADING: "Load single warehouse loading",
  SUCCESS: "Load single warehouse success",
  ERROR: "Load single warehouse error",
};

function* loadAllWarehouseWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllWarehouseAPI, payload);
    yield put(loadAllWarehouse(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_WAREHOUSE.ERROR, error });
  }
}

function* loadSingleWarehouseSagaWorker(action) {
  yield put(setSingleWarehouseNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleWarehouseAPI, payload);
    yield put(loadSingleWarehouse(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleWarehouseNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_WAREHOUSE.ERROR, error });
  }
}

export function* loadAllWarehouseSaga() {
  yield takeLatest(LOAD_ALL_WAREHOUSE.LOADING, loadAllWarehouseWorker);
}

export function* loadSingleWarehouseSaga() {
  yield takeLatest(
    LOAD_SINGLE_WAREHOUSE.LOADING,
    loadSingleWarehouseSagaWorker
  );
}
